import Rating from "react-rating";

import "./SkillExperience.css";
import { StarEmptyIcon, StarFullIcon } from "../../Icon/icons";
import Icon from "../../Icon/Icon";

const SkillExperience = ({ stars, starsSize, readonly, onHover, onChange }) => {
  const className = "star-" + (starsSize ?? "small");
  return (
    <Rating
      readonly={readonly}
      onHover={onHover}
      onChange={onChange}
      emptySymbol={
        <Icon className={className}>
          <StarEmptyIcon />
        </Icon>
      }
      fullSymbol={
        <Icon className={className}>
          <StarFullIcon />
        </Icon>
      }
      placeholderSymbol={
        <Icon className={className}>
          <StarFullIcon />
        </Icon>
      }
      placeholderRating={stars}
      initialRating={stars}
    />
  );
};

export default SkillExperience;
